// Heat Transfer Coefficient units with conversion factors to W/(m²·K)
export const heatTransferCoefficientUnits = [
  { id: 'watt-per-square-meter-kelvin', name: 'Watt per Square Meter Kelvin', symbol: 'W/(m²·K)', plural: 'Watts per Square Meter Kelvin', factor: 1 },
  { id: 'watt-per-square-meter-celsius', name: 'Watt per Square Meter Celsius', symbol: 'W/(m²·°C)', plural: 'Watts per Square Meter Celsius', factor: 1 },
  { id: 'kilowatt-per-square-meter-kelvin', name: 'Kilowatt per Square Meter Kelvin', symbol: 'kW/(m²·K)', plural: 'Kilowatts per Square Meter Kelvin', factor: 1000 },
  { id: 'calorie-per-second-square-centimeter-celsius', name: 'Calorie per Second Square Centimeter Celsius', symbol: 'cal/(s·cm²·°C)', plural: 'Calories per Second Square Centimeter Celsius', factor: 41868 },
  { id: 'kilocalorie-per-hour-square-meter-celsius', name: 'Kilocalorie per Hour Square Meter Celsius', symbol: 'kcal/(h·m²·°C)', plural: 'Kilocalories per Hour Square Meter Celsius', factor: 1.163 },
  { id: 'btu-per-hour-square-foot-fahrenheit', name: 'BTU per Hour Square Foot Fahrenheit', symbol: 'BTU/(h·ft²·°F)', plural: 'BTUs per Hour Square Foot Fahrenheit', factor: 5.678263 },
  { id: 'btu-per-second-square-foot-fahrenheit', name: 'BTU per Second Square Foot Fahrenheit', symbol: 'BTU/(s·ft²·°F)', plural: 'BTUs per Second Square Foot Fahrenheit', factor: 20441.748 },
  { id: 'joule-per-second-square-meter-kelvin', name: 'Joule per Second Square Meter Kelvin', symbol: 'J/(s·m²·K)', plural: 'Joules per Second Square Meter Kelvin', factor: 1 },
];

export const popularHeatTransferCoefficientConversions = [
  { from: 'watt-per-square-meter-kelvin', to: 'btu-per-hour-square-foot-fahrenheit' },
  { from: 'btu-per-hour-square-foot-fahrenheit', to: 'watt-per-square-meter-kelvin' },
  { from: 'watt-per-square-meter-kelvin', to: 'kilowatt-per-square-meter-kelvin' },
  { from: 'watt-per-square-meter-celsius', to: 'watt-per-square-meter-kelvin' },
  { from: 'calorie-per-second-square-centimeter-celsius', to: 'watt-per-square-meter-kelvin' },
  { from: 'kilocalorie-per-hour-square-meter-celsius', to: 'btu-per-hour-square-foot-fahrenheit' },
];

export const getUnitById = (id) => heatTransferCoefficientUnits.find(unit => unit.id === id);

export const convertHeatTransferCoefficient = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert heat transfer coefficient units and learn the conversion formula.`;
};
